import {useAppSelector} from "../../../../redux/hooks";
import {
  getDoesMySongsPageHaveSearchValue
} from "../../../songs-router/modules/my-songs-page-store/mySongsPage.selectors";
import {mySongsPageStore} from "../../../songs-router/modules/my-songs-page-store/mySongsPage.store";
import {logger} from "../../../../services/log/logger";

export interface ISongsMobileSearchControlAccessLogic {
  isMobileSearchActive: boolean;
  isFiltersActive: boolean;
  handleMobileSearchDisplayToggle: () => void;
}

export const useSongsMobileSearchControlAccessLogic = (): ISongsMobileSearchControlAccessLogic => {
  const isMobileMenuActive = useAppSelector(() => mySongsPageStore.isMenuActive(`mobile.search`));
  const doesSearchHaveValue = useAppSelector(getDoesMySongsPageHaveSearchValue);

  const isMobileSearchActive: boolean = (isMobileMenuActive || doesSearchHaveValue);

  logger.userAction.debug({
    message: `search mobile`,
    data: [
      {key: `isMobileSearchActive`, value: isMobileSearchActive},
      {key: `isMobileMenuActive`, value: isMobileMenuActive},
      {key: `doesSearchHaveValue`, value: doesSearchHaveValue},
    ]
  });

  return {
    isMobileSearchActive,
    isFiltersActive: false,
    handleMobileSearchDisplayToggle: () => mySongsPageStore.toggleActiveMenu(`mobile.search`),
  };
}
